import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { LineItemType } from '../../../../enums/lineItemType';
import { EditModalMultiSelect } from './multiSelectQuantity/multipleQuantity';
import { SingleSelectQuantity } from './singleSelectQuantity/singleQuantity';
import { SliderSingleQuantity } from './sliderSingleSelectQuantity/sliderSingleQuantity';
import './index.scss';

export const EditModal = ({
  cart,
  lineItemId,
  isOpen,
  toggleModal,
  showCustomQtySlider,
}) => {
  const mainItem: any = cart.lineItems[lineItemId][0].data;
  const cartItem: any = cart.lineItems[lineItemId];
  let multiDisplayObj = {};

  const getMultiDisplayDataObj = (cartItem) => {
    cartItem.forEach(({ data }) => {
      if (data.type === LineItemType.MAINITEM) {
        const attributeValues = Object.values(
          data?.multiSelectData?.editData?.attributeValues
        );
        (attributeValues as any).forEach((item) => {
          multiDisplayObj[item.attributeValue] = item;
        });
      } else if (data.type === LineItemType.SUBITEM) {
        const subItemAttributeValue = (
          Object.values(data?.multiSelectData?.editData?.attributeValues) as any
        ).find(({ qty }) => qty > 0);
        multiDisplayObj[subItemAttributeValue.attributeValue] =
          subItemAttributeValue;
      }
    });
  };

  if (mainItem?.multiSelectData?.isExist === true) {
    getMultiDisplayDataObj(cartItem);
  }

  return (
    <>
      {!showCustomQtySlider ? (
        mainItem?.multiSelectData?.isExist ? (
          <EditModalMultiSelect
            cart={cart}
            lineItemId={lineItemId}
            multiDataObj={multiDisplayObj}
            isOpen={isOpen}
            toggleModal={toggleModal}
            attributeDisplayKey={mainItem?.multiSelectData?.editData?.attribute}
          />
        ) : (
          <SingleSelectQuantity
            cart={cart}
            lineItemId={lineItemId}
            isOpen={isOpen}
            toggleModal={toggleModal}
            showCustomQtySlider={showCustomQtySlider}
          />
        )
      ) : (
        <SliderSingleQuantity
          cart={cart}
          lineItemId={lineItemId}
          isOpen={isOpen}
          toggleModal={toggleModal}
        />
      )}
    </>
  );
};
